// extracted by mini-css-extract-plugin
module.exports = {"simulatorContainer":"JobSimulator_simulatorContainer__3tsex","paramInput":"JobSimulator_paramInput__WMF-e","input":"JobSimulator_input__3_1e8"};